import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';

export interface UserIdentity {
  userEntityRef: string;
  ownershipEntityRefs: string[];
}

/**
 * Hook to get current user's identity and group memberships
 */
export const useUserIdentity = (): UserIdentity | undefined => {
  const identityApi = useApi(identityApiRef);

  const { value } = useAsync(async () => {
    const identity = await identityApi.getBackstageIdentity();

    return {
      userEntityRef: identity.userEntityRef,
      ownershipEntityRefs: identity.ownershipEntityRefs,
    };
  }, [identityApi]);

  return value;
};
